import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import { API } from "../../Redux/actions/API";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Select from "react-select";
import axios from "axios";
import { IdPrefix } from "../../App";

function AdminchangePassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const [secretkey, setsecretkey] = useState("");
  const [IP, setIP] = useState("");

  const [OldPassword, setOldPassword] = useState("");
  const [Password, setPassword] = useState("");
  const [CPassword, setCPassword] = useState("");

  useEffect(() => {
    const GetIp = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setIP(response.data.ip);
      } catch {
        toast.error("Error in getting IP");
      }
    };
    GetIp();
  }, []);

  const UpdatePassword_Api = async () => {
    try {
      if (
        OldPassword === "" ||
        OldPassword === null ||
        OldPassword === undefined
      ) {
        return toast.error("Enter Old Password");
      }

      if (Password === "" || Password === null || Password === undefined) {
        return toast.error("Enter New Password");
      }

      if (CPassword === "" || CPassword === null || CPassword === undefined) {
        return toast.error("Enter Confirm New Password");
      }

      if (CPassword !== Password) {
        return toast.error("New password and Confirm Password not matched");
      }

      let responceRight = await API?.post(
        "/AdminChangePassword",
        {
          loginid: userId,
          userId: "Rydon24EVAdmin",
          Oldpassword: OldPassword,
          NewPassword: Password,
          IP_address: IP,
          secretkey: secretkey,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      if (responceRight.data.data === "success") {
        toast.success(
          "Password Successfully Changed, Login Again with new password",
        );
        setTimeout(() => {
          navigate("/");
        }, 1000);
      } else {
        toast.error(responceRight.data.data);
      }
    } catch (e) {
      console.log("Update_Api", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Change Password</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div
                  class="box col-md-6"
                  // style={{ display: "none" }}
                >
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-12" style={{ marginLeft: "40px" }}>
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <h2>Update Password </h2>
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="form-group">
                                  <label>Old Password</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Old Password"
                                    value={OldPassword}
                                    onChange={(e) =>
                                      setOldPassword(e.target.value)
                                    }
                                    maxLength={20}
                                  />
                                </div>
                                <div className="form-group">
                                  <label>New Password</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter New Password"
                                    value={Password}
                                    onChange={(e) =>
                                      setPassword(e.target.value)
                                    }
                                    maxLength={20}
                                  />
                                </div>
                                <div className="form-group">
                                  <label>Confirm Password</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Confirm New Password"
                                    value={CPassword}
                                    onChange={(e) =>
                                      setCPassword(e.target.value)
                                    }
                                    maxLength={20}
                                  />
                                </div>

                                <div className="form-group">
                                  <label>Secret Key</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Secret key"
                                    value={secretkey}
                                    onChange={(e) =>
                                      setsecretkey(e.target.value)
                                    }
                                    maxLength={6}
                                  />
                                </div>

                                <div className="form-group">
                                  <div class="joinbtn d-flex flex-row-reverse me-auto">
                                    <button
                                      id="btnactivepswd"
                                      style={{
                                        color: "white",
                                        border: "solid 1px #ffff",
                                        padding: "10px 20px",
                                        marginTop: "20px",
                                        background: "blue",
                                      }}
                                      onClick={() => UpdatePassword_Api()}
                                    >
                                      Update Password
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminchangePassword;
